<template>
  <div id="app">
<!--    <router-view :key="$route.fullPath"/>-->
    <router-view/>
  </div>
</template>
<script>
import buildInfo from "@/buildInfo";
import config from '@/config'

export default {
  data(){
    return {
      hasSysDict: false,
    }
  },
  watch: {
    ['$route'+'.path']: {
      handler(){
        let path = this.$route.path;
        if (this.hasSysDict === false) {
          if (['/price', '/login', '/register', '/'].includes(path) === false) {
            this.$store.dispatch('sysDict/getSysDictList', {})
            this.hasSysDict = true
          }
        }
      },
      immediate: true
    }
  },
  mounted(){
    console.log('BT' + buildInfo.buildTime)
    console.log('config', JSON.stringify(config, null, 2))
    window.document.title = config.appName
  }
}
</script>
<style lang="scss">
#app {
  width: 100%;
  margin: 0 auto;
  min-width: 1300px;
  background: #fff;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;

}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  flex-shrink: 0; //不压缩
}

html {
  /* AntD 字体家族：https://ant.design/docs/spec/font-cn#%E5%AD%97%E4%BD%93%E5%AE%B6%E6%97%8F */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
  "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
  "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}


//对 element的组件 el-tabs 进行样式修改 -------------开始-------------
.el-tabs--card {
  .el-tabs__item.is-active {
    border-top: 2px solid #1890ff;
    box-sizing: content-box;
    border-bottom: 2px solid #ffffff;
  }

  .el-tabs__header .el-tabs__nav {
    border-radius: 0;
    border-top: none;
  }

  .el-tabs__item {
    border-top: 1px solid #dfe4ed;
    box-sizing: revert;
  }
}

//对 element的组件 el-tabs 进行样式修改 -------------结束-------------
body {
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #1890ff;
    background-color: #ffffff;
  }

  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0;
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 0;
  }
}
</style>
